import { LanguageCode, SntI18nModuleConfig } from '@senet-uiverse/i18n';
import { SntServerErrorsModuleConfig } from '@senet-uiverse/common';
import { NbGlobalPhysicalPosition } from '@nebular/theme';
import { createAvatars } from 'ui';

import projectJson from '../../project.json';

import { getBackendUrl } from './backend-url.config';

const BASE = {
  title: 'Senet ID',
  backendUrl: getBackendUrl(),
  version: projectJson.version,
  avatars: createAvatars('images/avatars'),
  toastConfig: {
    position: NbGlobalPhysicalPosition.TOP_RIGHT,
    duration: 5000,
    destroyByClick: true,
    containerClass: 'mt-14',
    defaultStatusIcons: {
      success: 'double-check',
      danger: 'warning',
    },
    hasIcon: false,
  },
  skeletonSettings: {
    animation: 'progress-dark',
    theme: {
      background: 'rgba(42, 51, 74, .5)',
      extendsFromRoot: true,
      borderRadius: '3px',
      display: 'block',
      margin: 0,
    },
  },
  nbDialogConfig: { hasBackdrop: true, autoFocus: false },
  i18nConfig: {
    prefix: './i18n/',
    defaultLang: LanguageCode.en,
    exclude: [
      LanguageCode.ar,
      LanguageCode.cs,
      LanguageCode.de,
      LanguageCode.es,
      LanguageCode.fr,
      LanguageCode.hu,
      LanguageCode.kk,
      LanguageCode.ky,
      LanguageCode.pl,
      LanguageCode.pt,
      LanguageCode.sl,
      LanguageCode.tr,
      LanguageCode.tg,
      LanguageCode.uz,
      LanguageCode.vi,
      LanguageCode.hi,
    ],
  } as SntI18nModuleConfig,
  errorConfig: {
    excludeKeys: ['code', 'status_code'],
  } as SntServerErrorsModuleConfig,
  queryConfig: {
    defaultOptions: {
      queries: {
        retry: false,
        refetchOnReconnect: true,
        refetchOnWindowFocus: false,
        refetchOnMount: false,
      },
    },
  },
  sentryDSN: 'https://03f6b9c1c54081679d4cc648d4010f82@sentry.senet.online/35',
  androidAppUrl: 'https://play.google.com/store/apps/details?id=com.enestech.senetid',
  iosAppUrl: 'https://apps.apple.com/ua/app/senet-id/id6748773918?l=uk',
} as const;

export default BASE;
